import React from "react";
import Heading from "./Heading";
// import { MainContainer, FlexContainer } from "../assets/styles/theme/styles";
import styled from "styled-components";
import { FlexContainer, MainContainer } from "../../assets/styles/theme/styles";
import Accordian from "./Accordian";

export default function Benefits({
  heading,
  text,
  imageSrc,
  fgvideo,
  link,
  btn,
  drn,
  video,
}) {
  return (
    <>
      <MainContainer>
        <FlexContainer flxdrn={drn}>
          <TextContainer>
            <h1
              style={{
                fontSize: "40px",
                fontWeight: "600",
              }}
            >
              {heading}
            </h1>
            <div style={{ paddingTop: "1rem" }}>
              <Accordian />
            </div>
          </TextContainer>
          <ImageColumn>
            {!video && <img src={imageSrc} alt="" />}
            {/* {video && (
              <BrowserCompatibility image={imageSrc} video={fgvideo} />
            )} */}
          </ImageColumn>
        </FlexContainer>
      </MainContainer>
    </>
  );
}

const TextContainer = styled.div`
  text-align: center;
  color: black;
  flex: 1;

  @media (min-width: 1020px) {
    text-align: left;
  }

  // > h1 {
  //   font-size: 2.5rem;
  //   margin-top: 24px;
  //   margin-bottom: 12px;
  //   color: black;
  // }

  > p {
    font-size: 17px;
    line-height: 30px;
    color: #5f627b;
  }
`;

const ImageColumn = styled.div`
  display: grid;
  place-items: center;
  flex: 1.2;

  > img {
    height: auto;
    width: 100%;
    max-width: 660px;
  }

  @media (min-width: 1020px) {
    > img {
      padding-right: 0;
      max-width: 1080px;

    }

    
  }

  video {
    width: 100%;

    @media (min-width: 720px) {
      width: 580px;
    }
`;

const BtnsWrapper = styled.div`
  gap: 2rem;
  display: flex;
  justify-content: center;

  @media (min-width: 1020px) {
    justify-content: flex-start;
  }
`;
